function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["onCancel", "onOk"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(r) { var n = this.s.return; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, throw: function _throw(r) { var n = this.s.return; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
import { onFormInputChange } from '@formily/core';
import { useDrawerMethod, useMount } from '@micun/form';
import { Button, Modal, Popconfirm } from 'antd';
import classNames from 'classnames';
import { message } from "../../../../components/GlobalMessage";
import dayjs from 'dayjs';
import { useCssInJs } from "../../../../hooks";
import stringify from 'json-stable-stringify';
import { customAlphabet } from 'nanoid';
import { apiTaskDraftSave } from "../../api/apiTaskDraftSave";
import { apiTaskOperate } from "../../api/apiTaskOperate";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useUnmount } from 'react-use';
import FormView from "../common/FormView";
import TextBar from "../common/TextBar";
import { getStyles } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var nanoid = customAlphabet('1234567890abcdef', 10);
function TaskHandle(props) {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    modal = _Modal$useModal2[0],
    contextHolder = _Modal$useModal2[1];
  var scrollerId = useMemo(function () {
    return "handleScroller_".concat(nanoid());
  }, []);
  var prefix = 'task-handle';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var businessCode = props.businessCode,
    taskOrderId = props.taskOrderId,
    flowOrderId = props.flowOrderId,
    operateType = props.operateType,
    _props$operateName = props.operateName,
    operateName = _props$operateName === void 0 ? '提交' : _props$operateName,
    rawForms = props.forms,
    forceUseDraft = props.forceUseDraft,
    orderDraftContent = props.orderDraftContent,
    onCancel = props.onCancel,
    onOk = props.onOk;
  var _useState = useState(rawForms),
    _useState2 = _slicedToArray(_useState, 2),
    forms = _useState2[0],
    setForms = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    draftSaving = _useState4[0],
    setDraftSaving = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    draftSaveTime = _useState6[0],
    setDraftSaveTime = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    draftUsed = _useState8[0],
    setDraftUsed = _useState8[1];
  var context = useMemo(function () {
    return {
      businessCode: businessCode,
      flowOrderId: flowOrderId,
      taskOrderId: taskOrderId,
      scene: 'taskHandle'
    };
  }, [businessCode, flowOrderId, taskOrderId]);
  var _useState9 = useState(function () {
      return forms.map(function (i) {
        return {
          type: i.type,
          current: null
        };
      });
    }),
    _useState10 = _slicedToArray(_useState9, 1),
    formRefs = _useState10[0];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    submitting = _useState12[0],
    setSubmitting = _useState12[1];
  var isUnloaded = useRef(false);
  useUnmount(function () {
    isUnloaded.current = true;
  });
  useEffect(function () {
    return function () {
      isUnloaded.current = true;
    };
  }, []);
  useEffect(function () {
    if (forceUseDraft || !orderDraftContent) {
      return;
    }
    var createTime = orderDraftContent.createTime;
    modal.confirm({
      title: '提示',
      content: "\u8349\u7A3F\u6700\u8FD1\u4FDD\u5B58\u65F6\u95F4\u4E3A\uFF1A\r\n".concat(createTime, "\r\n\u662F\u5426\u4F7F\u7528\uFF1F"),
      cancelText: '不使用',
      okText: '使用',
      onCancel: function onCancel() {
        setDraftUsed(false);
      },
      onOk: function onOk() {
        var nextForms = rawForms.map(function (form) {
          var _form$draftContent;
          var draftValue = (_form$draftContent = form.draftContent) === null || _form$draftContent === void 0 ? void 0 : _form$draftContent.formValue;
          return _objectSpread(_objectSpread({}, form), {}, {
            value: draftValue || ''
          });
        });
        setForms(nextForms);
        setDraftUsed(true);
      }
    });
  }, [forceUseDraft, modal, orderDraftContent, rawForms]);
  var getFormValues = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(validate) {
      var resultMap, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, formRef, values, errors, formValue, modifyMainFormValue;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resultMap = {
              HandleForm: null,
              MainForm: null
            };
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 3;
            _iterator = _asyncIterator(formRefs);
          case 5:
            _context.next = 7;
            return _iterator.next();
          case 7:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 30;
              break;
            }
            formRef = _step.value;
            if (!(formRef.current == null)) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("continue", 27);
          case 11:
            _context.prev = 11;
            if (!validate) {
              _context.next = 18;
              break;
            }
            _context.next = 15;
            return formRef.current.submit();
          case 15:
            _context.t0 = _context.sent;
            _context.next = 19;
            break;
          case 18:
            _context.t0 = formRef.current.values;
          case 19:
            values = _context.t0;
            resultMap[formRef.type] = values;
            _context.next = 27;
            break;
          case 23:
            _context.prev = 23;
            _context.t1 = _context["catch"](11);
            errors = _context.t1;
            throw errors;
          case 27:
            _iteratorAbruptCompletion = false;
            _context.next = 5;
            break;
          case 30:
            _context.next = 36;
            break;
          case 32:
            _context.prev = 32;
            _context.t2 = _context["catch"](3);
            _didIteratorError = true;
            _iteratorError = _context.t2;
          case 36:
            _context.prev = 36;
            _context.prev = 37;
            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 41;
              break;
            }
            _context.next = 41;
            return _iterator.return();
          case 41:
            _context.prev = 41;
            if (!_didIteratorError) {
              _context.next = 44;
              break;
            }
            throw _iteratorError;
          case 44:
            return _context.finish(41);
          case 45:
            return _context.finish(36);
          case 46:
            formValue = resultMap.HandleForm ? stringify(resultMap.HandleForm) : undefined;
            modifyMainFormValue = resultMap.MainForm ? stringify(resultMap.MainForm) : undefined;
            return _context.abrupt("return", {
              formValue: formValue,
              modifyMainFormValue: modifyMainFormValue
            });
          case 49:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 32, 36, 46], [11, 23], [37,, 41, 45]]);
    }));
    return function getFormValues(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var lastSaveTimeRef = useRef();
  var timer = useRef();
  var handleDraftSave = function handleDraftSave() {
    if (timer.current) {
      return;
    }
    // 节流
    var wait = forceUseDraft ? 1000 : 3 * 1000;
    timer.current = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$getFormValues, formValue, modifyMainFormValue, _yield$apiTaskDraftSa, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(draftSaving || isUnloaded.current)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            setDraftSaving(true);
            _context2.prev = 3;
            _context2.next = 6;
            return getFormValues();
          case 6:
            _yield$getFormValues = _context2.sent;
            formValue = _yield$getFormValues.formValue;
            modifyMainFormValue = _yield$getFormValues.modifyMainFormValue;
            if (!isUnloaded.current) {
              _context2.next = 11;
              break;
            }
            return _context2.abrupt("return");
          case 11:
            _context2.next = 13;
            return apiTaskDraftSave({
              taskOrderId: taskOrderId,
              operateType: operateType,
              formValue: formValue,
              modifyMainFormValue: modifyMainFormValue
            });
          case 13:
            _yield$apiTaskDraftSa = _context2.sent;
            data = _yield$apiTaskDraftSa.data;
            if (data) {
              lastSaveTimeRef.current = Date.now();
              setDraftSaveTime(dayjs().format('HH:mm:ss'));
            }
          case 16:
            _context2.prev = 16;
            setDraftSaving(false);
            timer.current = undefined;
            return _context2.finish(16);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3,, 16, 20]]);
    })), wait);
  };
  var handleDraftSaveRef = useRef(handleDraftSave);
  handleDraftSaveRef.current = handleDraftSave;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _yield$getFormValues2, formValue, modifyMainFormValue, _yield$apiTaskOperate, code, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setSubmitting(true);
            _context3.prev = 1;
            _context3.next = 4;
            return getFormValues(true);
          case 4:
            _yield$getFormValues2 = _context3.sent;
            formValue = _yield$getFormValues2.formValue;
            modifyMainFormValue = _yield$getFormValues2.modifyMainFormValue;
            console.log('submit', {
              formValue: formValue,
              modifyMainFormValue: modifyMainFormValue
            });
            _context3.next = 10;
            return apiTaskOperate({
              taskOrderId: taskOrderId,
              operateType: operateType,
              formValue: formValue,
              modifyMainFormValue: modifyMainFormValue
            });
          case 10:
            _yield$apiTaskOperate = _context3.sent;
            code = _yield$apiTaskOperate.code;
            data = _yield$apiTaskOperate.data;
            if (code === 0) {
              message.success("".concat(operateName, "\u6210\u529F"), 2);
              onOk(data);
            }
            _context3.next = 19;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](1);
            console.error(_context3.t0);
          case 19:
            _context3.prev = 19;
            setSubmitting(false);
            return _context3.finish(19);
          case 22:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 16, 19, 22]]);
    }));
    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  var formElements = useMemo(function () {
    return forms.map(function (_ref4, index) {
      var schema = _ref4.schema,
        value = _ref4.value,
        forceDraft = _ref4.forceDraft,
        draftContent = _ref4.draftContent;
      var val = forceDraft && draftContent ? draftContent.formValue : value;
      return /*#__PURE__*/_jsx("div", {
        className: "formView",
        children: /*#__PURE__*/_jsx(FormView, {
          scrollViewId: "#".concat(scrollerId),
          ref: formRefs[index],
          mode: "editable",
          schema: schema,
          value: val,
          context: context,
          effects: function effects() {
            onFormInputChange(function () {
              handleDraftSaveRef.current();
            });
          }
        })
      }, index);
    });
  }, [context, formRefs, forms, scrollerId]);
  var draftText = '';
  if (forceUseDraft || draftUsed) {
    draftText = '已加载为最新草稿内容';
  }
  if (draftSaving) {
    draftText = '自动保存中...';
  }
  if (draftSaveTime) {
    draftText = "\u8349\u7A3F\u5DF2\u4FDD\u5B58 ".concat(draftSaveTime);
  }
  return wrapSSR( /*#__PURE__*/_jsxs(_Fragment, {
    children: [contextHolder, /*#__PURE__*/_jsxs("div", {
      id: scrollerId,
      className: classNames(prefix, hashId),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "scroll",
        children: [draftText ? /*#__PURE__*/_jsx(TextBar, {
          className: "stickyBar",
          children: draftText
        }) : null, /*#__PURE__*/_jsx("div", {
          className: "formContainer",
          children: formElements
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "footer",
        children: /*#__PURE__*/_jsxs("div", {
          className: "actions",
          children: [/*#__PURE__*/_jsx(Button, {
            className: "btn",
            disabled: submitting,
            onClick: function onClick() {
              return onCancel();
            },
            children: "\u53D6\u6D88"
          }), /*#__PURE__*/_jsx(Popconfirm, {
            title: "\u786E\u8BA4\u63D0\u4EA4\u5417\uFF1F",
            onConfirm: handleSubmit,
            children: /*#__PURE__*/_jsx(Button, {
              className: "btn",
              type: "primary",
              disabled: submitting,
              children: "\u63D0\u4EA4"
            })
          })]
        })
      })]
    })]
  }));
}
var TaskHandleDrawer = function TaskHandleDrawer(params) {
  var onCancel = params.onCancel,
    onOk = params.onOk,
    rest = _objectWithoutProperties(params, _excluded);
  var _useDrawerMethod = useDrawerMethod(),
    render = _useDrawerMethod.render,
    setOpen = _useDrawerMethod.setOpen;
  var handleClose = useCallback(function () {
    setOpen(false);
    onCancel();
  }, [onCancel, setOpen]);
  var handleOk = useCallback(function (value) {
    onOk(value);
    setOpen(false);
  }, [onOk, setOpen]);
  return render({
    onClose: handleClose,
    title: '任务处理',
    width: 570,
    className: 'task-handle-drawer',
    styles: {
      body: {
        padding: 0
      }
    },
    children: /*#__PURE__*/_jsx(TaskHandle, _objectSpread(_objectSpread({}, rest), {}, {
      onCancel: handleClose,
      onOk: handleOk
    }))
  });
};
export var useTaskHandleDrawer = function useTaskHandleDrawer() {
  var mount = useMount();
  return function showTaskHandleDrawer(params) {
    return new Promise(function (resolve, reject) {
      mount( /*#__PURE__*/_jsx(TaskHandleDrawer, _objectSpread(_objectSpread({}, params), {}, {
        onOk: resolve,
        onCancel: reject
      })));
    });
  };
};